import styled from 'styled-components';

export const Wrapper = styled.div`
    padding-right: 16px;
`;

export const HeaderStyled = styled.div`
    user-select: none;
    padding-top: 4px;
`;
